import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { actions } from 'builder/modules/autoApply/autoApplyModule'
import { useCareerProfileData } from 'builder/hooks/useCareerProfileData'
import { AutoApplyForm } from 'builder/modules/autoApply/types'
import { mapCareerResponse } from './mappers'

export const useGetCareerProfile = () => {
  const dispatch = useDispatch()
  const [data, setData] = useState<AutoApplyForm | null>(null)

  const { careerProfileData, isCareerProfileLoading } = useCareerProfileData()

  useEffect(() => {
    if (!isCareerProfileLoading && careerProfileData) {
      const mappedData = mapCareerResponse(careerProfileData)
      dispatch(actions.updateForm(mappedData))
      setData(mappedData)
    }
  }, [careerProfileData, dispatch, isCareerProfileLoading])

  return {
    data,
    isLoading: isCareerProfileLoading,
  }
}
